module.exports = __webpack_public_path__ + "static/media/lloyd washing machine.8b8647b6.gif";


//////////////////
// WEBPACK FOOTER
// ./src/img/lloyd washing machine.gif
// module id = 350
// module chunks = 0